import {html} from '@isceco/widget-library2/external/lit'
import '@isceco/widget-library2/basic-elements/Title/Title'
import WebComponent from '../../WebComponent.js'

export default class Dashboard extends WebComponent {

  get translationFile() {
    return './views/Dashboard/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.render()
  }

  getTemplate() {
    return html`
      <isceco-title id="page-title"
                    text="${this.i18n.translate('page.title')}"
      ></isceco-title>
      <p style="font-weight: bold">${this.i18n.translate('wbf.bwo.title')}</p>
      <ul>
        <li><isceco-link text="${this.i18n.translate('wbf.bwo.fdr')}" url="wbf-bwo-fdr" /></li>
        <li><isceco-link text="${this.i18n.translate('wbf.bwo.statutenpruefung')}" url="wbf-bwo-statutenpruefung" /></li>
        <li><isceco-link text="${this.i18n.translate('wbf.bwo.forschungsgesuch')}" url="wbf-bwo-forschungsgesuch" /></li>
      </ul>
      <p style="font-weight: bold">${this.i18n.translate('wbf.seco.title')}</p>
      <ul>
        <li><isceco-link text="${this.i18n.translate('wbf.seco.beschwerdeformular')}" url="wbf-seco-beschwerdeformular" /></li>
        <p style="font-weight: bold">${this.i18n.translate('wbf.seco.sas.title')}</p>
        <ul>
          <li><isceco-link text="${this.i18n.translate('wbf.seco.sas.beschwerdeformular')}" url="wbf-seco-sas-beschwerdeformular" /></li>
        </ul>
      </ul>
      <p style="font-weight: bold">${this.i18n.translate('wbf.isceco.title')}</p>
      <ul>
        <li><isceco-link text="${this.i18n.translate('wbf.isceco.testformular')}" url="wbf-isceco-testformular" /></li>
      </ul>
      <p style="font-weight: bold">${this.i18n.translate('wbf.sbfi.title')}</p>
      <ul>
        <li><isceco-link text="${this.i18n.translate('wbf.sbfi.gesuchformular')}" url="wbf-sbfi-gesuchformular" /></li>
        <li><isceco-link text="${this.i18n.translate('wbf.sbfi.projektfinanzierungsgesuch')}" url="wbf-sbfi-projektfinanzierungsgesuch" /></li>
      </ul>
      <p style="font-weight: bold">${this.i18n.translate('wbf.other')}</p>
      <ul>
        <isceco-link text="${this.i18n.translate('wbf.nachtrag')}" url="wbf-nachtrag" />
      </ul>
    `
  }

}
customElements.define('eform-frontend-dashboard', Dashboard)
